module.exports = __webpack_public_path__ + "img/ec.ec7d16932.svg";